import { render, staticRenderFns } from "./dataInfoDY.vue?vue&type=template&id=4db5968e&scoped=true"
import script from "./dataInfoDY.vue?vue&type=script&lang=js"
export * from "./dataInfoDY.vue?vue&type=script&lang=js"
import style0 from "./dataInfoDY.vue?vue&type=style&index=0&id=4db5968e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db5968e",
  null
  
)

export default component.exports